var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-calendar',_vm._g(_vm._b({ref:"appointmentsCalendar",staticClass:".fc .fc-timegrid-col.fc-day-today",attrs:{"options":_vm.calendarOptions}},'full-calendar',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }